interface AboutModalProps {
  onClose: () => void;
}

export function AboutModal({ onClose }: AboutModalProps) {
  return (
    <div className="space-y-6 text-center">
      <div className="text-6xl">📊</div>
      <h3 className="text-2xl font-bold text-white">My Price Tracker</h3>
      <p className="text-gray-400">Version 1.0.0</p>

      <div className="bg-gray-700/50 rounded-xl p-6 border border-gray-700 text-left">
        <h4 className="font-semibold text-white mb-3">Fonctionnalités</h4>
        <ul className="space-y-2 text-gray-300">
          <li className="flex items-center gap-2">✅ Suivi des prix Amazon.fr</li>
          <li className="flex items-center gap-2">✅ Vérification automatique (2x/jour)</li>
          <li className="flex items-center gap-2">✅ Rafraîchissement manuel</li>
          <li className="flex items-center gap-2">✅ Alertes par email (Resend)</li>
          <li className="flex items-center gap-2">✅ Historique des prix avec graphiques</li>
          <li className="flex items-center gap-2">✅ Interface web responsive</li>
          <li className="flex items-center gap-2">✅ Hébergement Cloudflare Workers/Pages</li>
        </ul>
      </div>

      <div className="bg-gray-700/50 rounded-xl p-6 border border-gray-700 text-left">
        <h4 className="font-semibold text-white mb-3">Technologies</h4>
        <div className="flex flex-wrap gap-2">
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">React 18</span>
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">TypeScript</span>
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">Vite</span>
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">Tailwind CSS</span>
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">Recharts</span>
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">Cloudflare Workers</span>
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">Cloudflare D1</span>
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">Cloudflare Pages</span>
          <span className="px-3 py-1 bg-gray-600 rounded-full text-sm">Resend</span>
        </div>
      </div>

      <div className="text-sm text-gray-500">
        <p>Développé avec ❤️ pour suivre vos produits Amazon préférés</p>
        <p className="mt-1">Hébergé sur l'edge network de Cloudflare</p>
      </div>

      <button
        onClick={onClose}
        className="btn btn-primary w-full max-w-xs mx-auto mt-4"
      >
        Fermer
      </button>
    </div>
  );
}